import { memo, useCallback } from 'react';
import ClientTypeahead from './ClientTypeahead';

export const GuestLastnameField = memo(function GuestLastnameField({
    fieldName,
    roomIndex,
    guestIndex,
    guestLastname,
    lastnameRelatedField,
    lastnameSuggestionsMenuOptions,
    onSelectClient,
    onGuestUpdate,
}) {
    const handleChange = useCallback((event) => {
        onGuestUpdate(roomIndex, guestIndex, 'lastname', event.target.value);
    }, [onGuestUpdate, roomIndex, guestIndex]);

    return (
        <ClientTypeahead
            value={guestLastname}
            name={fieldName}
            onChange={handleChange}
            displayKey="client_lastname"
            searchParamName="last-name"
            relatedField={lastnameRelatedField}
            onSelectClient={onSelectClient}
            suggestionsMenuOptions={lastnameSuggestionsMenuOptions} />
    );
});
